const topics = [
  { id: 1, name: '暑期档综艺', heat: '98.6万', tag: '热', color: 'bg-primary-500' },
  { id: 2, name: '顶流恋情曝光', heat: '87.3万', tag: '爆', color: 'bg-accent-500' },
  { id: 3, name: '新剧口碑翻车', heat: '76.1万', tag: '热', color: 'bg-primary-500' },
  { id: 4, name: '网红翻车现场', heat: '65.8万', tag: '新', color: 'bg-secondary-500' },
  { id: 5, name: '音乐节风波', heat: '54.2万', tag: '热', color: 'bg-primary-500' },
  { id: 6, name: '电竞圈大事件', heat: '49.7万', tag: '新', color: 'bg-secondary-500' },
  { id: 7, name: '品牌代言争议', heat: '43.5万', tag: '', color: '' },
  { id: 8, name: '脱口秀金句', heat: '38.9万', tag: '', color: '' },
  { id: 9, name: '短视频神作', heat: '32.4万', tag: '新', color: 'bg-secondary-500' },
  { id: 10, name: '社会热点快评', heat: '28.1万', tag: '', color: '' },
];

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            🔥 热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            实时追踪全网热度最高的话题标签，掌握今日吃瓜风向标
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2.5 md:gap-3">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href="#topics"
              className="group relative inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              {topic.tag && (
                <span className={`${topic.color} text-background-50 text-[10px] font-label font-bold px-1.5 py-0.5 rounded-full leading-none whitespace-nowrap`}>
                  {topic.tag}
                </span>
              )}
              <span className="text-sm text-foreground-700 group-hover:text-primary-600 font-medium whitespace-nowrap">
                {topic.name}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}